import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useCustomStyles = makeStyles((theme: Theme) =>
  createStyles({
    feedbackPageContainer: {
      padding: '20px 50px 120px 57px',
      gridArea: 'pageContent',
      ['@media (max-width:920px) and (min-width: 280px)']: {
        padding: '24px 15px 120px 15px',
        overflowX: 'hidden',
      },
    },
    feedbackPageSearch: {
      width: '100%',
    },
    PagePaginationContainer: {
      width: '100%',
      marginTop: '10px',
      ['@media (max-width:920px) and (min-width: 280px)']: {
        padding: '0px 5px 0px 7px !important',
        marginTop: '18px',
      },
    },
    FeedbackTitleStyle: {
      height: '63px',
      display: 'flex',
      alignItems: 'center',
      paddingLeft: '24px',
      background: '#ffffff',

      '& span': {
        fontFamily: 'Calibre-R-Regular',
        fontSize: '16px',
        lineHeight: '20px',
        textAlign: 'left',
        color: '#2E5881',
      },
    },
    FeedbackExtContentStyle: {
      padding: '10px 20px',
      marginTop: '10px',
      width: '100%',

      '& div:first-of-type a': {
        fontFamily: 'Calibre-R-Regular',
        fontSize: '15px',
        lineHeight: '20px',
        textAlign: 'left',
        color: '#2E5881',
      },
    },
    FeedbackExtGridStyle: {
      display: 'flex',
      marginTop: '10px',
      width: '100%',
      ['@media (max-width:920px) and (min-width: 280px)']: {
        flexDirection: 'column',
      },
      '& section': {
        backgroundColor: theme.palette.background.paper,
        padding: '20px',

        '& > div:first-of-type': {
          fontFamily: 'Calibre-R-Regular',
          fontSize: '12px',
          lineHeight: '16px',
        },
      },
      '& > section:nth-of-type(1)': {
        flex: '1',
        '& div': {
          marginTop: '10px',
          // minWidth: '475px',
        },
      },
      '& > section:nth-of-type(2)': {
        flex: '1',
        '& .feedback-info-title': {
          height: '40px',
          boxShadow: '0px 0px 0px black',
          fontFamily: 'Calibre-R-Regular',
          fontSize: '16px',
          lineHeight: '20px',
          textAlign: 'left',
        },
        '& .feedback-spacer': {
          height: '1px',
          width: '100%',
          background: '#cccccc',
        },
        '& .feedback-info': {
          marginLeft: '-20px',
          '& section': {
            fontFamily: 'Calibre-R-Regular',
            fontSize: '14px',
            lineHeight: '20px',
          },

          '& section:nth-child(2)': {
            marginTop: '-20px',
            ['@media (max-width:920px) and (min-width: 280px)']: {
              marginTop: '-30px',
            },
          },
          '& section:nth-child(3)': {
            marginTop: '-35px',
          },
          '& section:nth-child(4)': {
            marginTop: '-20px',
            ['@media (max-width:920px) and (min-width: 280px)']: {
              marginTop: '-30px',
            },
          },
        },
      },
    },
    FeedbackDesc: {
      marginLeft: '20px',
      ['@media (max-width:920px) and (min-width: 280px)']: {
        marginTop: '20px',
        marginLeft: '0',
      },
    },

    Feedbackfields: {
      width: '100% ',
    },
    feedbackSubmitBtn: {
      marginTop: '30px !important',
    },
    submitRegisterBtn: {
      ['@media (max-width:920px) and (min-width: 280px)']: {
        width: '100% ',
      },
    },
    extDocMt20Style: {
      marginTop: '20px',
    },
    CardTitleStyle: {
      height: '80px',
      position: 'relative',

      '& div:nth-of-type(1)': {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        background: '#3C73A9',
        fontfamily: 'Calibre-R-Regular',
        fontSize: '20px',
        lineHeight: '24px',
        letterSpacing: '-0.015em',
        textAlign: 'left',
      },
      '& .card-icon-button': {
        position: 'absolute',
        top: '0px',
        right: '0px',
        color: 'white',
      },
    },
    CardColorStyle: {
      backgroundImage: 'none',
      background: '#3C73A9',
    },
    CardContentStyle: {
      fontfamily: 'Calibre-R-Regular',
      fontSize: '14px',
      lineHeight: '20px',
      letterSpacing: '0px',
      textAlign: 'left',
      color: '#26262699',
    },
    CardActionsStyle: {
      display: 'flex',

      '& section:nth-of-type(1)': {
        fontFamily: 'Calibre-R-Regular',
        fontSize: '12px',
        lineHeight: '18px',
        letterSpacing: '0.005em',
        textAlign: 'left',
        color: 'rgba(38, 38, 38, 0.6)',
        flex: '1',
      },
      '& section:nth-of-type(2)': {
        fontFamily: 'Calibre-R-Regular',
        fontSize: '16px',
        lineHeight: '16px',
        textAlign: 'left',
        color: '#435254',
      },
      '& .user': {
        color: '#000000',
        fontFamily: 'Calibre-R-Regular',
        fontSize: '14px',
      },
    },
    ContentHeaderStyle: {
      display: 'flex',

      '& > div:first-of-type': {
        display: 'flex',
        flex: '1 1 auto',

        '& > div:first-of-type': {
          width: '186px',
          border: '1px solid #cccccc',

          '& > div > div': {
            padding: '3px',
          },
        },

        '& > div:nth-of-type(2)': {
          width: '250px',
          marginLeft: '20px',
          background: '#ffffff',
          border: '1px solid #cccccc',
          borderRadius: '3px',

          '& > div > div': {
            width: '100%',
            underline: 'none',
            padding: '4px 2px 2px 2px',
          },
        },
      },
    },
    EmptyStateStyle: {
      '& > div > div > div': {
        marginTop: '190px',
        paddingLeft: '80px',
      },
    },
    SearchByStyle: {
      background: 'white',
      '& > div:first-of-type': {
        width: '100%',
        '& select': {
          padding: '6px 10px',
          background: 'white',
        },
        '& option': {
          padding: '4px',
        },
      },
    },
  }),
);
